import { dashboardApi } from "../api/dashboardApi";
import { getToken } from "../utils/getToken";

export const dashboardService = {
  getDashboardData: async (
    brand: string,
    segment?: string,
    segmentId?: number,
    fromDate?: Date | string,
    toDate?: Date | string,
    period?: string,
    filterPDPA?: number | null,
    filterBrand?: string[] | null,
    filterStore?: string[] | null,
    filterPurchaseBrand?: string[] | null,
    filterPurchaseStore?: string[] | null,
    segmentsIds?: number[] | null,
    filterRecency?: number[] | null,
    filterFrequency?: number[] | null,
    filterMonetary?: number[] | null,
    filterCampaign?: number | null
  ) => {
    const token = getToken();
    if (!token) return null;

    try {
      const response = await dashboardApi.getDashboardData(
        token,
        brand,
        segment,
        segmentId,
        fromDate,
        toDate,
        period,
        filterPDPA,
        filterBrand,
        filterStore,
        filterPurchaseBrand,
        filterPurchaseStore,
        segmentsIds,
        filterRecency,
        filterFrequency,
        filterMonetary,
        filterCampaign
      );
      return response.data.result;
    } catch (error) {
      console.error("Failed to fetch dashboard data:", error);
      return null;
    }
  },
  getMember: async (
    brandId: string,
    segment?: string,
    segmentId?: number,
    fromDate?: Date | string,
    toDate?: Date | string,
    period?: string,
    filterPDPA?: number | null,
    filterBrand?: string[] | null,
    filterStore?: string[] | null,
    filterPurchaseBrand?: string[] | null,
    filterPurchaseStore?: string[] | null,
    includeVoucher?: boolean,
    includePoint?: boolean,
    segmentsIds?: number[] | null,
    filterRecency?: number[] | null,
    filterFrequency?: number[] | null,
    filterMonetary?: number[] | null,
    filterCampaign?: number | null
  ): Promise<any | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response = await dashboardApi.getMember(
          token,
          brandId,
          segment,
          segmentId,
          fromDate,
          toDate,
          period,
          filterPDPA,
          filterBrand,
          filterStore,
          filterPurchaseBrand,
          filterPurchaseStore,
          includeVoucher,
          includePoint,
          segmentsIds,
          filterRecency,
          filterFrequency,
          filterMonetary,
          filterCampaign
        );
        return response;
      }
      return null;
    } catch (error) {
      console.error("Failed to get member:", error);
      return null;
    }
  },
  cleanBrandCache: async (brandId: string): Promise<any | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response = await dashboardApi.cleanBrandCache(token, brandId);
        return response;
      }
      return null;
    } catch (error) {
      console.error("Failed to clean cache:", error);
      return null;
    }
  },
  getOldestMemberSignup: async (brandId: string): Promise<any | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response = await dashboardApi.getOldestMemberSignup(
          token,
          brandId
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to get oldest member signup :", error);
      return null;
    }
  },
};
